import { render, staticRenderFns } from "./WalletsList.vue?vue&type=template&id=c5612256&scoped=true&"
import script from "./WalletsList.vue?vue&type=script&lang=js&"
export * from "./WalletsList.vue?vue&type=script&lang=js&"
import style0 from "./WalletsList.vue?vue&type=style&index=0&id=c5612256&lang=scss&scoped=true&"
import style1 from "./WalletsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5612256",
  null
  
)

export default component.exports